export const theme = {
    colors: {
        background: '#E2E2E2',
        textDark: '#000',
        textLight: '#fff'
    }
}